export default __webpack_public_path__ + "static/media/pro-elevate-bbl-banner-3.3a41a8e2.jpg";